module.exports = __webpack_public_path__ + "media/bargin.d2187b54.mp3";